!function(a,b,c){var d=window.matchMedia;"undefined"!=typeof module&&module.exports?module.exports=c(d):"function"==typeof define&&define.amd?define(function(){return b[a]=c(d)}):b[a]=c(d)}("enquire",this,function(a){"use strict";function b(a,b){var c,d=0,e=a.length;for(d;e>d&&(c=b(a[d],d),c!==!1);d++);}function c(a){return"[object Array]"===Object.prototype.toString.apply(a)}function d(a){return"function"==typeof a}function e(a){this.options=a,!a.deferSetup&&this.setup()}function f(b,c){this.query=b,this.isUnconditional=c,this.handlers=[],this.mql=a(b);var d=this;this.listener=function(a){d.mql=a,d.assess()},this.mql.addListener(this.listener)}function g(){if(!a)throw new Error("matchMedia not present, legacy browsers require a polyfill");this.queries={},this.browserIsIncapable=!a("only all").matches}return e.prototype={setup:function(){this.options.setup&&this.options.setup(),this.initialised=!0},on:function(){!this.initialised&&this.setup(),this.options.match&&this.options.match()},off:function(){this.options.unmatch&&this.options.unmatch()},destroy:function(){this.options.destroy?this.options.destroy():this.off()},equals:function(a){return this.options===a||this.options.match===a}},f.prototype={addHandler:function(a){var b=new e(a);this.handlers.push(b),this.matches()&&b.on()},removeHandler:function(a){var c=this.handlers;b(c,function(b,d){return b.equals(a)?(b.destroy(),!c.splice(d,1)):void 0})},matches:function(){return this.mql.matches||this.isUnconditional},clear:function(){b(this.handlers,function(a){a.destroy()}),this.mql.removeListener(this.listener),this.handlers.length=0},assess:function(){var a=this.matches()?"on":"off";b(this.handlers,function(b){b[a]()})}},g.prototype={register:function(a,e,g){var h=this.queries,i=g&&this.browserIsIncapable;return h[a]||(h[a]=new f(a,i)),d(e)&&(e={match:e}),c(e)||(e=[e]),b(e,function(b){d(b)&&(b={match:b}),h[a].addHandler(b)}),this},unregister:function(a,b){var c=this.queries[a];return c&&(b?c.removeHandler(b):(c.clear(),delete this.queries[a])),this}},new g});
!function(a){a.fn.equalHeights=function(){var b=0,c=a(this);return c.each(function(){var c=a(this).innerHeight();c>b&&(b=c)}),c.css("height",b)},a("[data-equal]").each(function(){var b=a(this),c=b.data("equal");b.find(c).equalHeights()})}(jQuery);
/* Run function after window resize */
var afterResize=(function(){var t={};return function(callback,ms,uniqueId){if(!uniqueId){uniqueId="Don't call this twice without a uniqueId";}if(t[uniqueId]){clearTimeout(t[uniqueId]);}t[uniqueId]=setTimeout(callback,ms);};})();
/* Lazyloader for FlexSlider 2 */
!function(e){flexsliderLazyloaderInit=function(i){if(e(i).find("li img.sflazy").attr("src",""),i.vars.slideshow){var d=i.currentSlide;d==i.count-1?nextSlide=0:nextSlide=d+1,flexsliderLazyloaderCheck([nextSlide],i.slides)}},flexsliderLazyloaderLoad=function(e){var i=e.animatingTo;i==e.count-1?nextSlide=0:nextSlide=i+1,0==i?prevSlide=e.count-1:prevSlide=i-1,flexsliderLazyloaderCheck([i,nextSlide,prevSlide],e.slides)},flexsliderLazyloaderCheck=function(i,d){e.each(i,function(i,l){var r=e(d[l]).find("img").attr("data-src");"undefined"!=typeof r&&r!==!1&&e(d[l]).find("img").attr("src",r).removeAttr("data-src")})}}(jQuery);
//* Ajaxify.js.liquid *//

/* ================ SLATE ================ */ 
window.theme = window.theme || {};

theme.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document)
  .on('shopify:section:load', this._onSectionLoad.bind(this))
  .on('shopify:section:unload', this._onSectionUnload.bind(this))
  .on('shopify:section:select', this._onSelect.bind(this))
  .on('shopify:section:deselect', this._onDeselect.bind(this))
  .on('shopify:block:select', this._onBlockSelect.bind(this))
  .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

theme.Sections.prototype = _.assignIn({}, theme.Sections.prototype, {
  _createInstance: function(container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');

    constructor = constructor || this.constructors[type];

    if (_.isUndefined(constructor)) {
      return;
    }

    var instance = _.assignIn(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function(evt) {
    var container = $('[data-section-id]', evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function(evt) {
    this.instances = _.filter(this.instances, function(instance) {
      var isEventInstance = (instance.id === evt.detail.sectionId);

      if (isEventInstance) {
        if (_.isFunction(instance.onUnload)) {
          instance.onUnload(evt);
        }
      }

      return !isEventInstance;
    });
  },

  _onSelect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onSelect)) {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onDeselect)) {
      instance.onDeselect(evt);
    }
  },

  _onBlockSelect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onBlockSelect)) {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onBlockDeselect)) {
      instance.onBlockDeselect(evt);
    }
  },

  register: function(type, constructor) {
    this.constructors[type] = constructor;

    $('[data-section-type=' + type + ']').each(function(index, container) {
      this._createInstance(container, constructor);
    }.bind(this));
  }
});

/* ================ MODULES ================ */
/* eslint-disable no-new */
window.timber = window.timber || {};

timber.cacheSelectors = function () {
  timber.cache = {
    // General
    $html: $('html'),
    $body: $('body'),
    $breadcrumbs: $('.breadcrumb'),

    // Navigation
    $navigation: $('#accessibleNav'),
    $hasDropdownItem: $('.site-nav--has-dropdown'),
    $menuToggle: $('.menu-toggle'),

    // Product Page
    
    $productImageWrap: $('#productPhoto'),
    $productImage: $('#productPhotoImg'),
    $thumbImages: $('#productThumbs').find('a.product-photo-thumb'),
    $shareButtons: $('.social-sharing'),

    // Collection Pages
    $collectionFilters: $('#collectionFilters'),
    $advancedFilters: $('.advanced-filters'),
    $toggleFilterBtn: $('#toggleFilters'),

    // Cart Pages
    $emptyCart: $('#EmptyCart'),
    $ajaxCartContainer: $('#ajaxifyCart'),
    cartNoCookies: 'cart--no-cookies',

    // Equal height elements
    $featuredContainer: $('.featured-box').closest('.grid-uniform'),   
    $productGridImages: $('.product-grid-image')
    
    
  };
};

timber.cacheVariables = function () {
  timber.vars = {
    // Breakpoints (from timber.scss.liquid)
    bpLarge: 1024,

    // MediaQueries (from timber.scss.liquid)
    mediaQueryLarge     : 'screen and (min-width: 1024px)',
    isLargeBp : false,
    isTouch: timber.cache.$html.hasClass('supports-touch')
  }
};

timber.init = function () {
  FastClick.attach(document.body);
  timber.cacheSelectors();
  timber.cacheVariables();

  timber.cache.$html.removeClass('no-js').addClass('js');
  if ('ontouchstart' in window) {
    timber.cache.$html.removeClass('no-touch').addClass('touch');
  }

  timber.initCart();
  
  timber.equalHeights();
  
  timber.responsiveVideos();
  timber.toggleFilters();


  
};

timber.accessibleNav = function () {
  var $nav = timber.cache.$navigation,
      $allLinks = $nav.find('a'),
      $topLevel = $nav.children('li').find('a'),
      $parents = $nav.find('.site-nav--has-dropdown'),
      $subMenuLinks = $nav.find('.site-nav--dropdown').find('a'),
      activeClass = 'nav-hover',
      focusClass = 'nav-focus';

  // Mouseenter
  $parents.on('mouseenter', function(evt) {
    var el = $(this);

    if (!el.hasClass(activeClass)) {
      evt.preventDefault();
    }

    showDropdown($(this));
  });

  $parents.on('mouseleave', function() {
    hideDropdown($(this));
  });

  $subMenuLinks.on('click', function(evt) {
    // Prevent touchstart on body from firing instead of link
    evt.stopImmediatePropagation();
  });

  $allLinks.focus(function() {
    handleFocus($(this));
  });

  $allLinks.blur(function() {
    removeFocus($topLevel);
  });

  // accessibleNav private methods
  function handleFocus (el) {
    var $subMenu = el.next('ul'),
        hasSubMenu = $subMenu.hasClass('site-nav--dropdown') ? true : false,
        isSubItem = $('.site-nav--dropdown').has(el).length,
        $newFocus = null;

    // Add focus class for top level items, or keep menu shown
    if ( !isSubItem ) {
      removeFocus($topLevel);
      addFocus(el);
    } else {
      $newFocus = el.closest('.site-nav--has-dropdown').find('a');
      addFocus($newFocus);
    }
  }

  function showDropdown (el) {
    el.addClass(activeClass);

    setTimeout(function() {
      timber.cache.$body.on('touchstart', function() {
        hideDropdown(el);
      });
    }, 250);
  }

  function hideDropdown ($el) {
    $el.removeClass(activeClass);
    timber.cache.$body.off('touchstart');
  }

  function addFocus ($el) {
    $el.addClass(focusClass);
  }

  function removeFocus ($el) {
    $el.removeClass(focusClass);
  }
};

timber.responsiveNav = function () {
  $(window).resize(function () {
    afterResize(function(){
      // Replace original nav items and remove more link
      timber.cache.$navigation.append($('#moreMenu--list').html());
      $('#moreMenu').remove();
      timber.alignMenu();
      timber.accessibleNav();
    }, 200, 'uniqueID');
  });
  timber.alignMenu();
  timber.accessibleNav();
};

timber.alignMenu = function () {
  var $nav = timber.cache.$navigation,
      w = -5,
      i = 0;
  wrapperWidth = $nav.outerWidth() - 101,
    menuhtml = '';

  if ( window.innerWidth < timber.vars.bpLarge ) {
    return;
  }

  $.each($nav.children(), function () {
    var $el = $(this);

    // Ignore hidden customer links (for mobile)
    if (!$el.hasClass('large-hide')) {
      w += $el.outerWidth(true);
    }

    if (wrapperWidth == w) {
      menuhtml += $('<div>').append($el.clone()).html();
      $el.remove();

      // Ignore hidden customer links (for mobile)
      if (!$el.hasClass('large-hide')) {
        i++;
      }
    }
  });

  if (wrapperWidth == w) {
    $nav.append(
      '<li id="moreMenu" class="site-nav--has-dropdown">'
      + '<a href="#">' + theme.strings.navigation.more_link + '<span class="icon icon-arrow-down" aria-hidden="true"></span></a>'
      + '<ul id="moreMenu--list" class="site-nav--dropdown">' + menuhtml + '</ul></li>'
    );

    if (i <= 1) {
      // Bail, and replace original nav items
      timber.cache.$navigation.append($('#moreMenu--list').html());
      $('#moreMenu').remove();
    }
  }
};

timber.toggleMenu = function () {
  var $doc = $(document);
  var showDropdownClass = 'show-dropdown';
  var showNavClass = 'show-nav';

  timber.cache.$menuToggle.on('click', function() {
    timber.cache.$html.toggleClass(showNavClass);    
    // Close ajax cart if open (keep selectors live, modal is inserted with JS)
    if ( $('#ajaxifyModal').hasClass('is-visible') ) {
      $('#ajaxifyModal').removeClass('is-visible');
      timber.cache.$html.addClass(showNavClass);
    }
  });
  
  if (window.matchMedia("(max-width: 1023px)").matches) { 
  function dropDown(elem) {
    var acc = document.getElementsByClassName(elem);
    var i;   

    for (i = 0; i < acc.length; i++) {
      acc[i].addEventListener("click", function() {
        
        if(elem == "level1-title" || elem == "level2-title") {
          var panelBefore = this.nextElementSibling;
          var panel = panelBefore.nextElementSibling;
          panelBefore.classList.toggle("active");
        }
        else {
          this.classList.toggle("active");
          var panel = this.nextElementSibling;  
        }    
        
        if (panel.style.display === "block") {
          panel.style.display = "none";       
        } else {
          panel.style.display = "block";
        }
      });
    }
  }
  dropDown("level1-title");
  dropDown("level1");
  dropDown("level2-title");
  dropDown("level2");
  
  jQuery(document).on('shopify:section:load', function(){
    dropDown("level1-title");
    dropDown("level1");
    dropDown("level2-title");
    dropDown("level2");
  });
  }

  
  // Open sub navs on small screens
  /*timber.cache.$hasDropdownItem.on('click', function(evt) {
    var $el = $(this);

    if (!$el.hasClass(showDropdownClass) && timber.vars.isTouch || !$el.hasClass(showDropdownClass) && timber.cache.$html.hasClass(showNavClass)) {
      evt.preventDefault();
      $el.addClass(showDropdownClass);
      //$doc.on('click', handleClickOutsideDropdown);
    }

    function handleClickOutsideDropdown (evt) {
      var $target = $(evt.target);

      if (!$target.is($el) && !$.contains($el[0], $target[0])) {
        $el.removeClass(showDropdownClass);
        //$doc.off('click', handleClickOutsideDropdown)
      }
    }
  })*/
};

timber.initCart = function() {
  if (!timber.cookiesEnabled()) {
    timber.cache.$emptyCart.addClass(timber.cache.cartNoCookies);
    timber.cache.$ajaxCartContainer.addClass(timber.cache.cartNoCookies);
  }
};

timber.cookiesEnabled = function() {
  var cookieEnabled = navigator.cookieEnabled;
  if (!cookieEnabled){
    document.cookie = 'testcookie';
    cookieEnabled = (document.cookie.indexOf('testcookie') !== -1);
  }
  return cookieEnabled;
};

timber.equalHeights = function () {
  var $featuredBoxImageArray = [];
  var $featuredBoxArray = [];

  timber.cache.$featuredContainer.each(function() {
    $featuredBoxImageArray.push($(this).find('.featured-box--image'));
    $featuredBoxArray.push($(this).find('.featured-box'));
  });
    

  $(window).on('load', function() {
    resizeElements();
  });

  $(window).resize(function() {
    afterResize(function() {
      resizeElements();
    }, 250, 'id');
  });

  function resizeElements() {
    var featuredContainerLength = timber.cache.$featuredContainer.length;
    for (var i = 0; i < featuredContainerLength ; i++) {
      $featuredBoxImageArray[i].css('height', 'auto').equalHeights();
      $featuredBoxArray[i].css('height','auto').equalHeights();
    }
    timber.cache.$productGridImages.css('height', 'auto').equalHeights();
  }
  
 
};

timber.responsiveVideos = function () {
  var $iframeVideo = $('iframe[src*="youtube.com/embed"], iframe[src*="player.vimeo"]');
  var $iframeReset = $iframeVideo.add('iframe#admin_bar_iframe');

  $iframeVideo.each(function () {
    // Add wrapper to make video responsive but not for video sections
    if(!$(this).parent('div.video-wrapper').length) {
      $(this).wrap('<div class="video-wrapper"></div>');
    };
  });

  $iframeReset.each(function () {
    // Re-set the src attribute on each iframe after page load
    // for Chrome's "incorrect iFrame content on 'back'" bug.
    // https://code.google.com/p/chromium/issues/detail?id=395791
    // Need to specifically target video and admin bar
    this.src = this.src;
  });
};

timber.toggleFilters = function () {
  if ( timber.cache.$collectionFilters.length ) {
    timber.cache.$toggleFilterBtn.on('click', function() {
      timber.cache.$toggleFilterBtn.toggleClass('is-active');
      timber.cache.$collectionFilters.slideToggle(200);

      // Scroll to top of filters if user is down the page a bit
      if ( $(window).scrollTop() > timber.cache.$breadcrumbs.offset().top ) {
        $('html, body').animate({
          scrollTop: timber.cache.$breadcrumbs.offset().top
        });
      }
    });
  }
};

timber.sortFilters = function () {
  timber.cache.$advancedFilters.each(function () {
    var $el = $(this),
        $tags = $el.find('li'),
        aNumber = /\d+/,
        sorted = false;
    $tags.sort(function (a, b) {
      a = parseInt( aNumber.exec( $(a).text() ), 10 );
      b = parseInt( aNumber.exec( $(b).text() ), 10 );
      if ( isNaN(a)  || isNaN(b) ) {
        return;
      }
      else {
        sorted = true;
        return a - b;
      }
    });
    if (sorted) {
      $el.append($tags);
    }
  });
};

timber.formatMoney = function (val) {

       

  return val;
};

timber.formatSaleTag = function (val) {
  // If not using multiple currencies
  if (moneyFormat.indexOf('money') === -1) {
    // If we use amount
    if ( (moneyFormat.indexOf('{{amount}}') > -1) && (moneyFormat.indexOf('.') === -1) ) {
      // If there are no cents or money amount is more than 10, remove decimals
      if ( (val.indexOf('.00') > -1) || parseInt(val.replace(/[^0-9]/g, ''), 10) > 1000 ) {
        return val.split('.')[0];
      }
    }
    // If we use amount_with_comma_separator
    else if (moneyFormat.indexOf('{{amount_with_comma_separator}}') > -1) {
      // If there are no cents or money amount is more than 10, remove decimals
      if ( (val.indexOf(',00') > -1) || parseInt(val.replace(/[^0-9]/g, ''), 10) > 1000 ) {
        return val.split(',')[0];
      }
    }
  }
  return val;
};



// Initialize Timber's JS on docready
$(timber.init)

/*!
 * imagesLoaded PACKAGED v4.1.1
 * JavaScript is all like "You images are done yet or what?"
 * MIT License
 */

!function(t,e){"function"==typeof define&&define.amd?define("ev-emitter/ev-emitter",e):"object"==typeof module&&module.exports?module.exports=e():t.EvEmitter=e()}("undefined"!=typeof window?window:this,function(){function t(){}var e=t.prototype;return e.on=function(t,e){if(t&&e){var i=this._events=this._events||{},n=i[t]=i[t]||[];return-1==n.indexOf(e)&&n.push(e),this}},e.once=function(t,e){if(t&&e){this.on(t,e);var i=this._onceEvents=this._onceEvents||{},n=i[t]=i[t]||{};return n[e]=!0,this}},e.off=function(t,e){var i=this._events&&this._events[t];if(i&&i.length){var n=i.indexOf(e);return-1!=n&&i.splice(n,1),this}},e.emitEvent=function(t,e){var i=this._events&&this._events[t];if(i&&i.length){var n=0,o=i[n];e=e||[];for(var r=this._onceEvents&&this._onceEvents[t];o;){var s=r&&r[o];s&&(this.off(t,o),delete r[o]),o.apply(this,e),n+=s?0:1,o=i[n]}return this}},t}),function(t,e){"use strict";"function"==typeof define&&define.amd?define(["ev-emitter/ev-emitter"],function(i){return e(t,i)}):"object"==typeof module&&module.exports?module.exports=e(t,require("ev-emitter")):t.imagesLoaded=e(t,t.EvEmitter)}(window,function(t,e){function i(t,e){for(var i in e)t[i]=e[i];return t}function n(t){var e=[];if(Array.isArray(t))e=t;else if("number"==typeof t.length)for(var i=0;i<t.length;i++)e.push(t[i]);else e.push(t);return e}function o(t,e,r){return this instanceof o?("string"==typeof t&&(t=document.querySelectorAll(t)),this.elements=n(t),this.options=i({},this.options),"function"==typeof e?r=e:i(this.options,e),r&&this.on("always",r),this.getImages(),h&&(this.jqDeferred=new h.Deferred),void setTimeout(function(){this.check()}.bind(this))):new o(t,e,r)}function r(t){this.img=t}function s(t,e){this.url=t,this.element=e,this.img=new Image}var h=t.jQuery,a=t.console;o.prototype=Object.create(e.prototype),o.prototype.options={},o.prototype.getImages=function(){this.images=[],this.elements.forEach(this.addElementImages,this)},o.prototype.addElementImages=function(t){"IMG"==t.nodeName&&this.addImage(t),this.options.background===!0&&this.addElementBackgroundImages(t);var e=t.nodeType;if(e&&d[e]){for(var i=t.querySelectorAll("img"),n=0;n<i.length;n++){var o=i[n];this.addImage(o)}if("string"==typeof this.options.background){var r=t.querySelectorAll(this.options.background);for(n=0;n<r.length;n++){var s=r[n];this.addElementBackgroundImages(s)}}}};var d={1:!0,9:!0,11:!0};return o.prototype.addElementBackgroundImages=function(t){var e=getComputedStyle(t);if(e)for(var i=/url\((['"])?(.*?)\1\)/gi,n=i.exec(e.backgroundImage);null!==n;){var o=n&&n[2];o&&this.addBackground(o,t),n=i.exec(e.backgroundImage)}},o.prototype.addImage=function(t){var e=new r(t);this.images.push(e)},o.prototype.addBackground=function(t,e){var i=new s(t,e);this.images.push(i)},o.prototype.check=function(){function t(t,i,n){setTimeout(function(){e.progress(t,i,n)})}var e=this;return this.progressedCount=0,this.hasAnyBroken=!1,this.images.length?void this.images.forEach(function(e){e.once("progress",t),e.check()}):void this.complete()},o.prototype.progress=function(t,e,i){this.progressedCount++,this.hasAnyBroken=this.hasAnyBroken||!t.isLoaded,this.emitEvent("progress",[this,t,e]),this.jqDeferred&&this.jqDeferred.notify&&this.jqDeferred.notify(this,t),this.progressedCount==this.images.length&&this.complete(),this.options.debug&&a&&a.log("progress: "+i,t,e)},o.prototype.complete=function(){var t=this.hasAnyBroken?"fail":"done";if(this.isComplete=!0,this.emitEvent(t,[this]),this.emitEvent("always",[this]),this.jqDeferred){var e=this.hasAnyBroken?"reject":"resolve";this.jqDeferred[e](this)}},r.prototype=Object.create(e.prototype),r.prototype.check=function(){var t=this.getIsImageComplete();return t?void this.confirm(0!==this.img.naturalWidth,"naturalWidth"):(this.proxyImage=new Image,this.proxyImage.addEventListener("load",this),this.proxyImage.addEventListener("error",this),this.img.addEventListener("load",this),this.img.addEventListener("error",this),void(this.proxyImage.src=this.img.src))},r.prototype.getIsImageComplete=function(){return this.img.complete&&void 0!==this.img.naturalWidth},r.prototype.confirm=function(t,e){this.isLoaded=t,this.emitEvent("progress",[this,this.img,e])},r.prototype.handleEvent=function(t){var e="on"+t.type;this[e]&&this[e](t)},r.prototype.onload=function(){this.confirm(!0,"onload"),this.unbindEvents()},r.prototype.onerror=function(){this.confirm(!1,"onerror"),this.unbindEvents()},r.prototype.unbindEvents=function(){this.proxyImage.removeEventListener("load",this),this.proxyImage.removeEventListener("error",this),this.img.removeEventListener("load",this),this.img.removeEventListener("error",this)},s.prototype=Object.create(r.prototype),s.prototype.check=function(){this.img.addEventListener("load",this),this.img.addEventListener("error",this),this.img.src=this.url;var t=this.getIsImageComplete();t&&(this.confirm(0!==this.img.naturalWidth,"naturalWidth"),this.unbindEvents())},s.prototype.unbindEvents=function(){this.img.removeEventListener("load",this),this.img.removeEventListener("error",this)},s.prototype.confirm=function(t,e){this.isLoaded=t,this.emitEvent("progress",[this,this.element,e])},o.makeJQueryPlugin=function(e){e=e||t.jQuery,e&&(h=e,h.fn.imagesLoaded=function(t,e){var i=new o(this,t,e);return i.jqDeferred.promise(h(this))})},o.makeJQueryPlugin(),o});

/* ================ SECTIONS ================ */ 
window.theme = window.theme || {};

theme.HeaderSection = (function() {

  function Header() {
    timber.cacheSelectors();
    timber.toggleMenu();

    $(window).on('load', timber.responsiveNav).resize();
  }

  return Header;
})();
if($('body').hasClass('template-index')) {
  theme.Slideshow = (function(el) {    
    this.cache = {
      $slider: $(el),
      sliderArgs: {
        animation: 'slide',
        animationSpeed: 500,
        pauseOnHover: true,
        keyboard: false,
        slideshow: $(el).data('slider-home-auto'),
        slideshowSpeed: $(el).data('slider-home-rate'),
        smoothHeight: true,
        before: function(slider) {
          $(slider).resize();
          $(slider).find('.slide').not('.flex-active-slide').removeClass('slide-hide');
        },
        after: function(slider) {
          $(slider).find('.slide').not('.flex-active-slide').addClass('slide-hide');
        },
        start: function(slider) {
          $(slider).find('.slide').not('.flex-active-slide').addClass('slide-hide');
          if ($(slider).find('.slide').not('.clone').length === 1) {
            $(slider).find('.flex-direction-nav').remove();
          }
          $(window).trigger('resize');
          slider.addClass('loaded');
          if ($('#slider').data('loaded-index') != undefined) {
            $('#slider').flexslider($('#slider').data('loaded-index'));
          }
        }
      }
    }
    if (this.cache.$slider.find('li').length === 1) {
      this.cache.sliderArgs.touch = false;
    }

    this.cache.$slider.flexslider(this.cache.sliderArgs)

  });

  theme.slideshows = theme.slideshows || {};

  theme.SlideshowSection = (function() {

    function SlideshowSection(container) {
      var $container = this.$container = $(container);
      var id = $container.attr('data-section-id');
      var slideshow = this.slideshow = '#heroSlider--' + id;
      theme.slideshows[slideshow] = new theme.Slideshow(slideshow);
    }

    return SlideshowSection;

  })();

  theme.SlideshowSection.prototype = _.assignIn({}, theme.SlideshowSection.prototype, {

    onUnload: function() {
      delete theme.slideshows[this.slideshow];
    },

    onBlockSelect: function(evt) {
      var $slideshow = $(this.slideshow);
      var $slide = $('#slide--' + evt.detail.blockId + ':not(.clone)');

      var slideIndex = $slide.data('flexslider-index');
      var $slideImg = $slide.find('img') || $slide.find('svg');

      $slide.imagesLoaded($slideImg,function(){
        $slideshow.flexslider(slideIndex);
        $slideshow.flexslider("pause");
      });

    },

    onBlockDeselect: function() {
      $(this.slideshow).flexslider('play');
    }

  });

}
/* eslint-disable no-new */
theme.Product = (function() {
  var defaults = {
    selectors: {
      addToCart: '#addToCart',
      addToCartProduct: '#addToCartProduct',
      productPrice: '#productPrice',
      comparePrice: '#comparePrice',
      addToCartText: '#addToCartText',
      addToCartProductText: '#addToCartProductText',
      addToCheckoutText: '#addToCheckoutText',      
      quantityElements: '.quantity-selector, label + .js-qty',
      optionSelector: 'productSelect',
    }
  };

  function Product(container) {
    var $container = this.$container = $(container);
    var sectionId = $container.attr('data-section-id');

    this.settings = $.extend({}, defaults, {
      sectionId: sectionId,
      enableHistoryState: true,
      showComparePrice: $container.attr('data-show-compare-at-price'),
      stockSetting: $container.attr('data-stock'),
      incomingMessage: $container.attr('data-incoming-transfer'),
      selectors: {
        $originalSelectorId: 'productSelect-' + sectionId,
        $addToCart: $('#addToCart'),
        $addToCartProduct: $('#addToCartProduct'),
        $addToCheckout: $('#addToCheckout'),
        $SKU: $('.variant-sku'),
        $productPrice: $('#productPrice-' + sectionId),
        $comparePrice: $('#comparePrice-' + sectionId),
        $addToCartText: $('.addToCartText-' + sectionId),
        $addToCartProductText: $('.addToCartText-' + sectionId),
        $addToCheckoutText: $('#addToCheckoutText-' + sectionId),
        $quantityElements: $('#quantity-selector-' + sectionId),
        $variantQuantity: $('#variantQuantity-' + sectionId),
        $variantIncoming: $('#variantIncoming-' + sectionId),
        $productImageWrap: $('#productPhoto-' + sectionId),
        $productImage: $('#productPhotoImg-' + sectionId),
        $thumbImages: $('#productThumbs-' + sectionId).find('a.product-photo-thumb'),
      }
    });

    // disable history state if on homepage
    if($('body').hasClass('template-index')) {
      this.settings.enableHistoryState = false;
    }

    // Stop parsing if we don't have the product json script tag when loading
    // section in the Theme Editor
    if (!$('#ProductJson-' + sectionId).html()) {
      return;
    }

    // this.productSingleObject = JSON.parse(document.getElementById('ProductJson-' + sectionId).innerHTML);
    this.productSingleObject = JSON.parse($('#ProductJson-' + sectionId).html());
    this.addVariantInfo();
    this.init();

    // Pre-loading product images to avoid a lag when a thumbnail is clicked, or
    // when a variant is selected that has a variant image
    /*Shopify.Image.preload(this.productSingleObject.images);*/
  }

  Product.prototype = _.assignIn({}, Product.prototype, {
    init: function() {
      this.initProductVariant();
      this.addQuantityButtons();
      this.productImageSwitch();
      this.initBreakpoints();

      if (timber.vars.isLargeBp) {
        productImageZoom();
      }
    },

    onUnload: function() {
      this.$container.off(this.settings.sectionId);
    },

    addVariantInfo: function() {
      if (!this.productSingleObject) {
        return;
      }

      if (this.settings.stockSetting === 'false' && this.settings.incomingMessage === 'false'){
        return;
      }

      var variantInfo = JSON.parse($('#VariantJson-' + this.settings.sectionId).html());
      for (var i = 0; i < variantInfo.length; i++) {
        $.extend(this.productSingleObject.variants[i], variantInfo[i]);
      }
    },

    addQuantityButtons: function(){
      if (this.settings.selectors.$quantityElements){
        this.settings.selectors.$quantityElements.show();
       
        this.qtySelectors();
       
      }

    },

    qtySelectors: function() {

      validateQty = function (qty) {
        if((parseFloat(qty) == parseInt(qty)) && !isNaN(qty)) {
          // We have a valid number!
          return qty;
        } else {
          // Not a number. Default to 1.
          return 1;
        }
      };

      // Change number inputs to JS ones, similar to ajax cart but without API integration.
      // Make sure to add the existing name and id to the new input element
      var numInputs = $('input[type="number"]');

      // Qty selector has a minimum of 1 on the product page
      // and 0 in the cart (determined on qty click)
      var qtyMin = 0;

      if (numInputs.length) {
        numInputs.each(function() {
          var el = $(this),
              currentQty = parseInt(el.val()),
              inputName = el.attr('name'),
              inputId = el.attr('id');

          var itemAdd = currentQty + 1,
              itemMinus = currentQty - 1,
              itemQty = currentQty;

          var source   = $("#jsQty").html(),
              template = Handlebars.compile(source),
              data = {
                key: el.data('id'),
                itemQty: itemQty,
                itemAdd: itemAdd,
                itemMinus: itemMinus,
                inputName: inputName,
                inputId: inputId
              };

          // Append new quantity selector then remove original
          el.after(template(data)).remove();
        });

        // Setup listeners to add/subtract from the input
        $('.js--qty-adjuster').on('click', function() {
          var el = $(this),
              id = el.data('id'),
              qtySelector = el.siblings('.js--num'),
              qty = parseInt( qtySelector.val() );

          var qty = validateQty(qty);
          qtyMin = timber.cache.$body.hasClass('template-product') ? 1 : qtyMin;

          // Add or subtract from the current quantity
          if (el.hasClass('js--add')) {
            qty = qty + 1;
          } else {
            qty = qty <= qtyMin ? qtyMin : qty - 1;
          }

          // Update the input's number
          qtySelector.val(qty);
        });

      }
    },

    initBreakpoints: function () {

      var self = this;
      var $container = self.$container;
      self.zoomType = $container.data('zoom-enabled');

      if (!$('html').hasClass('lt-ie9')) {
        enquire.register(timber.vars.mediaQueryLarge, {
          match: function() {
            if (self.zoomType) {
              // reinit product zoom
              productImageZoom();
            }

            timber.vars.isLargeBp = true;
          },
          unmatch: function() {
            if (self.zoomType) {

              if ((self.settings.selectors.$productImage).length) {
                // remove event handlers for product zoom on mobile
                self.settings.selectors.$productImage.off();
                self.settings.selectors.$productImageWrap.trigger('zoom.destroy');
              }
            }

            timber.vars.isLargeBp = false;
          }
        });
      }

    },

    productImageSwitch: function() {
      if (!this.settings.selectors.$thumbImages.length) {
        return;
      }

      var self = this;

      // Switch the main image with one of the thumbnails
      // Note: this does not change the variant selected, just the image
      self.settings.selectors.$thumbImages.on('click', function(evt) {
        evt.preventDefault();
        var newImage = $(this).attr('href');
        var newImageId = $(this).attr('data-image-id');

        self.switchImage(newImage, { id: newImageId }, self.settings.selectors.$productImage);

      });


    },

    switchImage: function (src, imgObject, el) {
      // Make sure element is a jquery object
      var $el = $(el);
      $el.attr('src', src);

      if (this.settings.selectors.$productImage.attr('data-zoom') && timber.vars.isLargeBp) {
        var zoomSrc = src.replace('_compact.','_1024x1024.').replace('_medium.','_1024x1024.').replace('_large.','_1024x1024.');
        $el.attr('data-zoom', zoomSrc);

        $(function() {
          productImageZoom();
        });
      }

    },

    initProductVariant: function() {
      // this.productSingleObject is a global JSON object defined in theme.liquid
      if (!this.productSingleObject) {
        return;
      }
      $('.selector-wrapper').hide();
      $('.cont-selector .selector-wrapper').attr('style','display:none');
      var self = this;
      this.optionSelector = new Shopify.OptionSelectors(self.settings.selectors.$originalSelectorId, {
        selectorClass: self.settings.selectors.$optionSelectorClass,
        product: self.productSingleObject,
        onVariantSelected: self.productVariantCallback,
        enableHistoryState: self.settings.enableHistoryState,
        settings: self.settings
      });

      // Clean up variant labels if the Shopify-defined
      // defaults are the only ones left
      this.simplifyVariantLabels(this.productSingleObject);

    },

    simplifyVariantLabels: function(productObject) {
      // Hide variant dropdown if only one exists and title contains 'Default'
      if (productObject.variants.length && productObject.variants[0].title.indexOf('Default') >= 0) {
        $('.selector-wrapper').hide();
        $('.cont-selector .selector-wrapper').attr('style','display:none');
      }
      
    },

    // **WARNING** This function actually inherits `this` from `this.optionSelector` not
    // from `product` when passed in as a callback for `option_selection.js`
    productVariantCallback: function(variant) {
      
      if (variant) {
        
        
        
        // Update variant image, if one is set
        if (variant.featured_image) {
          var newImg = variant.featured_image,
              el = this.settings.selectors.$productImage[0],
              zoomSrc = $(newImg).attr('src').replace('.jpg','_1024x1024.jpg').replace('.jpeg','_1024x1024.jpeg').replace('.png','_1024x1024.png'),
              $zoomImg = $('.zoomImg');
                   
          const nbVariantsIdsForSlide = 10;
          var templates = $('div').find("[data-section-slider-id]");
         
          
          for(let s=0; s < templates.length; s++) {

            var sliderId = "#"+$(templates[s]).attr('id'); 

			slidersProduct('.flexslider-product');
            
            for(i=0; i < nbVariantsIdsForSlide; i++) {
              let slideActif = $(sliderId+ " .flexslider-thumbnails").find("[data-variant-id='" + newImg.variant_ids[i] + "']");
              if(slideActif.length == 1) { 
                let slideActifSelected = slideActif.attr('data-position2');
                if(slideActifSelected !== undefined) {
                  $(sliderId+ ' .flexslider-product').flexslider(slideActifSelected - 1);                 
                }
                else {
                  $(sliderId+ ' .flexslider-product').flexslider(0);
                } 
              
              }
               

            }
          }
          
          /*for(i=0; i < nbVariantsIdsForSlide; i++) {
            let slideActif = $(".flexslider-thumbnails").find("[data-variant-id='" + newImg.variant_ids[i] + "']");
            if(slideActif.length == 1) { 
              let slideActifSelected = slideActif.attr('data-position2');
              if(slideActifSelected !== undefined) {
                $('.flexslider-product').flexslider(slideActifSelected - 1);
              }
              else {
                $('.flexslider-product').flexslider(0);
              } 
            }            
          }*/

          
          
          /*$('.single-option-selector').change(function() { 
          Shopify.Image.switchImage(newImg, el, this.switchImage);
          });        
          
          Shopify.Image.switchImage(newImg, el, this.switchImage);*/

          if (this.settings.selectors.$productImage.attr('data-zoom') && timber.vars.isLargeBp) {
            // reint zoom attributes on image variant
            this.settings.selectors.$productImage.attr('data-zoom', zoomSrc);
            $zoomImg.attr('src', zoomSrc);
          }
        }

        if (variant.available) {
          
          
          // We have a valid product variant, so enable the submit button
          this.settings.selectors.$addToCart.removeClass('disabled').prop('disabled', false);
          this.settings.selectors.$addToCartText.html("Ajouter au panier");
          this.settings.selectors.$addToCartProduct.removeClass('disabled').prop('disabled', false);
          this.settings.selectors.$addToCartProductText.html("Ajouter au panier");
          this.settings.selectors.$addToCheckout.removeClass('disabled').prop('disabled', false);
          this.settings.selectors.$addToCheckoutText.html("Acheter maintenant");

          this.settings.selectors.$variantQuantity.removeClass('is-visible');
          this.settings.selectors.$variantIncoming.removeClass('is-visible');

          if (variant.inventory_management) {
            // Show how many items are left, if below 10
            if (variant.inventory_quantity < 10 && variant.inventory_quantity > 0 && this.settings.stockSetting == 'true') {
              this.settings.selectors.$variantQuantity.html(theme.strings.product.only_left.replace('1', variant.inventory_quantity)).addClass('is-visible');
            }
          }

          // Show next ship date if quantity <= 0 and stock is incoming
          if (variant.inventory_quantity <= 0 && variant.incoming != null ) {
            if (variant.next_incoming_date != null){
              this.settings.selectors.$variantIncoming.html(theme.strings.product.will_be_in_stock_after.replace('[date]', variant.next_incoming_date)).addClass('is-visible');
            }
          }
        } else {          

          // Variant is sold out, disable the submit button
          this.settings.selectors.$addToCart.addClass('disabled').prop('disabled', true);
          this.settings.selectors.$addToCartText.html("Épuisé");
          this.settings.selectors.$addToCartProduct.addClass('disabled').prop('disabled', true);
          this.settings.selectors.$addToCartProductText.html("Épuisé");
          this.settings.selectors.$addToCheckout.addClass('disabled').prop('disabled', true);
          this.settings.selectors.$addToCheckoutText.html("Épuisé");
          this.settings.selectors.$variantQuantity.removeClass('is-visible');
          this.settings.selectors.$variantIncoming.removeClass('is-visible');

          // Show next stock incoming date if stock is incoming
          if (variant.inventory_management) {
            if (variant.incoming && this.settings.incomingMessage == 'true' && variant.incoming != null && variant.next_incoming_date != null) {
              this.settings.selectors.$variantIncoming.html(theme.strings.product.will_be_in_stock_after.replace('[date]', variant.next_incoming_date)).addClass('is-visible');
            }
          }

          this.settings.selectors.$quantityElements.hide();
        }

        // Regardless of stock, update the product price
        var customPrice = timber.formatMoney( Shopify.formatMoney(variant.price, moneyFormat) );   
        
        var customComparePrice = timber.formatMoney( Shopify.formatMoney(variant.compare_at_price, moneyFormat) ); 
        var a11yPrice = Shopify.formatMoney(variant.price, moneyFormat);
        
        var customPriceWithoutCurrency = "";    
        var customComparePriceWithoutCurrency = "";
        
              
        
        // v1 
         
        
        // v2
        
        var customPriceFormat = ' <span aria-hidden="true" class="so-price" id="so-price" data-compare-price="'+customComparePriceWithoutCurrency+'" data-price="'+customPriceWithoutCurrency+'" data-shipping-value="45" data-discount-qty2="0" data-discount-qty3="30">' + customPrice + '</span>';
         
        
        customPriceFormat += ' <span class="visually-hidden">' + a11yPrice + '</span>';

        // Show SKU
        this.settings.selectors.$SKU.html(variant.sku)

        if (this.settings.showComparePrice == 'true' ) {
          if (variant.compare_at_price > variant.price) {
            var comparePrice = timber.formatMoney(Shopify.formatMoney(variant.compare_at_price, moneyFormat));
            var a11yComparePrice = Shopify.formatMoney(variant.compare_at_price, moneyFormat);
            
            // v1 
             

            // v2
            
            customPriceFormat = ' <span aria-hidden="true" class="so-price" id="so-price" data-compare-price="'+customComparePriceWithoutCurrency+'" data-price="'+customPriceWithoutCurrency+'"  data-shipping-value="45" data-discount-qty2="0" data-discount-qty3="30">' + customPrice + '</span>';
            
             
            
            customPriceFormat += ' <span aria-hidden="true"><s>' + comparePrice + '</s></span>';
            customPriceFormat += ' <span class="visually-hidden"><span class="visually-hidden">Prix régulier</span> ' + a11yComparePrice + '</span>';
            customPriceFormat += ' <span class="visually-hidden"><span class="visually-hidden">Prix réduit</span> ' + a11yPrice + '</span>';
             
          }
        }
        
        // special offer v1 - free shipping - discount auto
        
        
        this.settings.selectors.$productPrice.html(customPriceFormat);

        // Also update and show the product's compare price if necessary
        if ( variant.compare_at_price > variant.price ) {
          var priceSaving = Shopify.formatMoney(variant.compare_at_price - variant.price, moneyFormat);
          
          var priceSaving = '<span class="price-sale2"> ' + priceSaving + '</span>';
          var priceSaving2 = timber.formatSaleTag( Shopify.formatMoney(variant.compare_at_price - variant.price, "") );
          var priceSaving2 = ((variant.compare_at_price - variant.price)/variant.compare_at_price*100).toFixed()+"%";
		         
          this.settings.selectors.$comparePrice.html("\u003cspan class='save-text'\u003eÉconomisez\u003c\/span\u003e [$]".replace('[$]', priceSaving + " <span class='price-saving-percent'><span class='parentheses'>(</span>-" + priceSaving2 + "<span class='parentheses'>)</span></span>")).show();
                   
        } 
        else {
          this.settings.selectors.$comparePrice.hide();
          
        }
        
        if (variant.compare_at_price == variant.price) {
          
          $('.main-content .amount-percent-true .product-meta .sale-tag').hide();
         
        }       
       

      } else {
        // The variant doesn't exist, disable submit button.
        // This may be an error or notice that a specific variant is not available.
        this.settings.selectors.$addToCart.addClass('disabled').prop('disabled', true);
        this.settings.selectors.$addToCartText.html(theme.strings.product.unavailable);
        this.settings.selectors.$addToCartProduct.addClass('disabled').prop('disabled', true);
        this.settings.selectors.$addToCartProductText.html(theme.strings.product.unavailable);
        this.settings.selectors.$addToCheckout.addClass('disabled').prop('disabled', true);
        this.settings.selectors.$addToCheckoutText.html(theme.strings.product.unavailable);
        this.settings.selectors.$variantQuantity.removeClass('is-visible');
        this.settings.selectors.$quantityElements.hide();
      }

    }

  });

  function productImageZoom() {

    var $productImageWrap = $('.productPhoto'),
        $productImage = $('.productPhotoImg');

    if (timber.vars.isLargeBp) {
      if (!$productImage.attr('data-zoom')) {
        return;
      }

      if (!$productImageWrap.length || timber.cache.$html.hasClass('supports-touch')) {
        return;
      };

      // Destroy zoom (in case it was already set), then set it up again
      $productImageWrap.trigger('zoom.destroy');
      $productImageWrap.addClass('image-zoom').zoom({
        url: $productImage.attr('data-zoom')
      });
    }
  }
  return Product;
})();
$(document).ready(function() {
  var sections = new theme.Sections();
  sections.register('header-section', theme.HeaderSection);
  sections.register('slideshow-section', theme.SlideshowSection);
  sections.register('product-template', theme.Product);
});


/* Applications */

// Size chart

$(document).ready(function() {
  
  function productTabs() {
    $('ul.tabs').each(function(){
      var active, content, links = $(this).find('a');
      active = links.first().addClass('active');
      content = $(active.attr('href'));
      links.not(':first').each(function () {
        $($(this).attr('href')).hide();
      });
      $(this).find('a').click(function(e){
        active.removeClass('active');
        content.hide();
        active = $(this);
        content = $($(this).attr('href'));
        active.addClass('active');
        content.show();
        return false;
      });
    });
  }
  productTabs();
  jQuery(document).on('shopify:section:load', function(){  
    productTabs();
  });
  
  if (window.matchMedia("(min-width: 800px)").matches) {  
    window.addEventListener('scroll', _.debounce(function(){ 
      var a = 112;
      var pos = $(window).scrollTop();
      
      if(pos > a) {
       
        $(".size-format-true .cont-header").css({'background':'rgba(255,255,255,0.75);'});        
        $(".header-fixed-true").addClass('header-scroll-on');
      }
      else {
      
        $(".size-format-true .cont-header").css({'background':'rgba(255,255,255,0.99);'});       
        $(".header-fixed-true").removeClass('header-scroll-on');
      }
    }, 200));
  }
});
$(window).on("load resize",function(e){  
  $('.template-collection .mono-produit-true').remove('aside');
  $('.template-collection .mono-produit-true .hr--offset-left').css('margin-left','0');  
  $('.template-collection .mono-produit-true .grid-item').removeClass('large--four-fifths'); 
  $('.template-collection .mono-produit-true .grid-item').removeClass('grid-border--left'); 
  
});

function slidersProduct(elem) {
 
  jQuery(elem).flexslider({
    // Lazy loading
    animationLoop: false,
    slideshow: false,   
    start: function(slider) { flexsliderLazyloaderInit(slider) },
    before: function(slider) { flexsliderLazyloaderLoad(slider) }
  });
  $(elem+ '.slider').flexslider({
    animation: "slide",
    controlNav: false,
    animationLoop: true,
    slideshow: false,    
    sync: ".carousel",
    start: function(slider){
      $('body').removeClass('loading');
    }
  });
  if (window.matchMedia("(max-width: 767px)").matches) {
    $('.carousel').flexslider({
      animation: "slide",
      controlNav: true,
      animationLoop: false,
      slideshow: true,
      itemWidth: 72,
      itemMargin: 6,
      asNavFor: '.slider'
    });
  }
  else {
    $('.carousel').flexslider({
      animation: "slide",
      controlNav: false,
      animationLoop: false,
      slideshow: false,
      itemWidth: 120,
      itemMargin: 10,
      touch: true,
      asNavFor: '.slider'
    });
  } 
}

slidersProduct('.flexslider-product');

function sliderRecommendedProducts() {
  
  jQuery('.slider-product').not('.slick-initialized').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    centerPadding:'0px',
    arrows: true,
    fade: false,
    infinite: true,
    asNavFor: '.slider-nav'
  });
  jQuery('.slider-nav').not('.slick-initialized').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    asNavFor: '.slider-product',
    dots: true,
    centerMode: true,
    centerPadding:'0px',
    infinite: true,
    focusOnSelect: true
  });
  jQuery('.template-product .slick-slider').not('.slick-initialized').slick({ 
    infinite: true,
    slidesToShow: 5,
    slidesToScroll: 5,
    dots: false,                 
    speed: 300,     
    responsive: [   
      {
        breakpoint: 900,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      }     
    ]
  });

  $( ".slick-next:after" ).click(function() {
    $('.slick-slide').delay(1000).fadeIn(0);
  });

}

sliderRecommendedProducts();
jQuery(document).on('shopify:section:load', function(){  
  sliderRecommendedProducts();
});

jQuery(".flexslider-index").flexslider({
  // Lazy loading
  animationLoop: true,
  slideshow: true,   
  start: function(slider) { flexsliderLazyloaderInit(slider) },
  before: function(slider) { flexsliderLazyloaderLoad(slider) }
});


if($("#showcdtimer").length > 0){ 
  $('#gdcdtimer').show(); 
}
else {
  $('#gdcdtimer').hide(); 
}
$(".cont-photos .flex-control-nav").hide();
$('.carousel-inner .item').eq(0).addClass('active');

$(document).ready(function() {   
  
  $('.search-bar').hover(function() {
    $( ".search-input" ).focus();
  });

  $(".product-variants option").each(function() {
    var text = $(this).text();
    text = text.replace("Default Title", "Prix");
    $(this).text(text);
  });   
  $(".product-variants2 option").each(function() {
    var text = $(this).text();
    text = text.replace("Default Title", "Prix");
    $(this).text(text);
  });
  var goContent = $(".slider-section").attr('id');
  setTimeout(function() {
    var sliderHeight = $(".slider-section").height();
    var HeaderSection = ($(".cont-header").height() -37);
    var HeaderSectionMobile = ($(".cont-header").height());
    $(".size-format-true .movearrow").eq(0).show();
    if (window.matchMedia("(max-width: 767px)").matches) {      
    }
    else {
      $('.movearrow').on('click', function() { 
       
        $('html,body').animate({
          scrollTop: ($("#" + goContent).offset().top) + sliderHeight},'slow');
      });
    }
  }, 1000);
  $('#accordion .panel-title a').click(function(){
    var $t = $(this);
    var $p = $t.parents('#accordion');
    var isClosed = $t.hasClass('collapsed');
    if(isClosed){
      if($p.find('.in').length){
        var $open = $p.find('.in')
        $open.slideUp( "300", function() {
          $open.removeClass('in');
        });
        $open.parents('.panel').find('.panel-title a').addClass('collapsed');
      }
      var $toOpen = $t.parents('.panel').find('.panel-collapse');
      $t.removeClass('collapsed');
      $toOpen.slideDown( "300", function() {
        $toOpen.addClass('in');
      });

    }else{
      var $open = $p.find('.panel-collapse')
      $open.slideUp( "slow", function() {
        $open.removeClass('in');
      });
      $open.parents('.panel').find('.panel-title a').addClass('collapsed');
    }
    return false;
  });
});
$(function(){$.fn.scrollToTop=function(){$(this).hide().removeAttr("href");if($(window).scrollTop()!="0"){$(this).fadeIn("slow")}var scrollDiv=$(this);$(window).scroll(function(){if($(window).scrollTop()=="0"){$(scrollDiv).fadeOut("slow")}else{$(scrollDiv).fadeIn("slow")}});$(this).click(function(){$("html, body").animate({scrollTop:0},"slow")})}}); 
$(function(){
  $("#toTop").scrollToTop();
});


$(window).on('load', function() {
if (window.matchMedia("(min-width: 1024px)").matches) {
    $(document).on('mousemove', '.frame', function(event) {

        var element = {
            width: $(this).width(),
            height: $(this).height()
        };

        var mouse = {
            x: event.pageX,
            y: event.pageY
        };

        var offset = $(this).offset();

        var origin = {
            x: (offset.left + (element.width / 2)),
            y: (offset.top + (element.height / 2))
        };

        var trans = {
            left: (origin.x - mouse.x) / 2,
            down: (origin.y - mouse.y) / 2
        };

        var transform = ("scale(2,2) translateX(" + trans.left + "px) translateY(" + trans.down + "px)");

        $(this).children(".zoom").css("transform", transform);

    });
    $(document).on('mouseleave', '.frame', function() {
        $(this).children(".zoom").css("transform", "none");
    });
    $("#sortBy option").each(function(i) {
        var $bestSelling = $(this).attr("value");
        if ($bestSelling == "best-selling") {
            $(this).hide();
        }
    });
 }
});
/* Header cart */
/* CGV */

$(document).ready(function() {
  $('body').on('click', '[name="checkout"], [name="goto_pp"], [name="goto_gc"]', function() {
    if ($('#agree').is(':checked')) {
      $(this).submit();
    } else {
      alert("Vous devez accepter les conditions générales de vente pour pouvoir passer commande.");
      return false;
    }
    });
    $('body').on('click', '.agree-checkout', function() {
    if ($('#agree2').is(':checked')) {
      $(this).submit();
    } else {
      alert("Vous devez accepter les conditions générales de vente pour pouvoir passer commande.");
      return false;
    }
    });
});

  

if (window.matchMedia("(min-width: 1024px)").matches) {
  /* megamenus */
  $(document).ready(function() {   
    $('.site-nav li').on('mouseenter touchstart', function() {
      $('.dropdown_container').removeClass('dropdown_open');
      var headerHeight = $('.cont-header').height();
      $this = $(this);  
      if(!$this.data('dropdown-rel')) {
        $('.dropdown_container').removeClass('dropdown_open');
      }   
      $('.size-format-true .dropdown').css('top', $('.cont-header').height());     
      if(typeof $this.data('dropdown-rel') !== "undefined") {
        $('.mega-menu-container .mega-menu').each(function(index){    
          if ($(this).data("dropdown") == $this.data('dropdown-rel')){
            $(this).addClass('dropdown_open');
          } 
        });
      }
    });

    window.addEventListener('scroll', _.debounce(function() {
      $('.size-format-true .dropdown').css('top', $('.cont-header').height());
    }, 200));
    if ($('.cont-header').hasClass('header-fixed-false')) {   
      $('.dropdown_container .dropdown').addClass('no-fixed');
      $('.size-format-true .breadcrumb').addClass('no-marge');
    }
    $(".dropdown_container").mouseleave(function(e){
      var $this = $(this);
      var bottom = $this.offset().top + $this.outerHeight();
      if(e.pageY >= bottom){ $('.dropdown_container').removeClass('dropdown_open'); } 
    });
    $(".grid-20").mouseenter(function(e){
      $('.dropdown_container').removeClass('dropdown_open');
    });
    $(".topheader").mouseenter(function(e){
      $('.dropdown_container').removeClass('dropdown_open');
    });
    $(document).mouseleave(function(e){
      $('.dropdown_container').removeClass('dropdown_open');
    });  
  });
}


function checkHeaderSize() {
  var headerHeight = $('.cont-header').height();
  var hasClassHeaderFixed = $('.cont-header').hasClass('header-fixed-true'); 
  
  $('.menu-toggle').on('click', function() {     
    
    if ($('html').hasClass('show-nav')) {
      $('.show-nav .nav-bar').attr('style','top:'+headerHeight+'px !important'); 
    }
    else {
      $('.nav-bar').attr('style','top:110% !important'); 
    }

  });

  if(hasClassHeaderFixed) {  
    var headerHeight = $('.cont-header').outerHeight();
    $('.main-content').attr('style','padding-top:'+(headerHeight + 25)+'px !important');
    $('.size-format-true.template-index .main-content').attr('style','padding-top:'+headerHeight+'px !important');

  } 
}

$(window).on("load resize",function(e){ 
  checkHeaderSize();
});


// Open the full screen search box
function openSearch() {
  const input = document.querySelectorAll(".search-overlay .search-input");
  document.getElementById("search-overlay").style.display = "block";
  setTimeout(function() {
    input[0].focus();

  }, 600);
}
// Close the full screen search box
function closeSearch() {
  document.getElementById("search-overlay").style.display = "none";
}
$(document).ready(function() {
  
  $(".update-cart").hide();
  $('.template-cart .cart__quantity-selector').change(function(){
    $( ".update-cart" ).click();
  });
  
  var regEx = /(\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*)/;

  $(".site-footer p").filter(function() {
    return $(this).html().match(regEx);
  }).each(function() {
    $(this).html($(this).html().replace(regEx, "<a href=\"mailto:$1\">$1</a>"));
  });
});
/* Menu icons */ 
       $(".site-nav > li").eq(0).addClass('site-nav-icon-7');                                           

jQuery(function() {
  
  // Current Ajax request.
  var currentAjaxRequest = null;
  // Grabbing all search forms on the page, and adding a .search-results list to each.
  var searchForms = jQuery('form[action="/search"]').css('position','relative').each(function() {
    // Grabbing text input.
    var input = jQuery(this).find('input[name="q"]');
    // Adding a list for showing search results.
    var offSet = input.position().top + input.innerHeight();
    jQuery('<ul class="search-results"></ul>').css( { 'position': 'absolute', 'left': '0px', 'top': '100%' } ).appendTo(jQuery(this)).hide();    
    // Listening to keyup and change on the text field within these search forms.
    input.attr('autocomplete', 'off').bind('keyup change', function() {
      // What's the search term?
      var term = jQuery(this).val() + "*";
      // What's the search form?
      var form = jQuery(this).closest('form');
      // What's the search URL?      
      
      var searchURL = '/search?type=product&q=' + term;
      // What's the search results list?
      var resultsList = form.find('.search-results');
      // If that's a new term and it contains at least 3 characters.
      if (term.length > 3 && term != jQuery(this).attr('data-old-term')) {
        // Saving old query.
        jQuery(this).attr('data-old-term', term);
        // Killing any Ajax request that's currently being processed.
        if (currentAjaxRequest != null) currentAjaxRequest.abort();
        // Pulling results.
        currentAjaxRequest = jQuery.getJSON(searchURL + '&view=json', function(data) {
          // Reset results.
          resultsList.empty();
          // If we have no results.
          if(data.results_count == 0) {
            // resultsList.html('<li><span class="title">No results.</span></li>');
            // resultsList.fadeIn(200);
            resultsList.hide();
          } else {
            // If we have results.
            jQuery.each(data.results, function(index, item) {
              var link = jQuery('<a></a>').attr('href', item.url);
              if (item.thumbnail.includes('no-image')) {
              link.append('<span class="thumbnail"></span>');
              }
              else {
                link.append('<span class="thumbnail"><img src="' + item.thumbnail + '" /></span>');
                
              }              
              link.append('<span class="title">' + item.title + '</span>');
              link.wrap('<li></li>');
              resultsList.append(link.parent());
            });
            // The Ajax request will return at the most 10 results.
            // If there are more than 10, let's link to the search results page.
            if(data.results_count > 10) {
              resultsList.append('<li><span class="title"><a href="' + searchURL + '">Translation missing: fr.general.search.search_all_products (' + data.results_count + ')</a></span></li>');
            }
            resultsList.fadeIn(200);
          }        
        });
      }
    });
  });
  // Clicking outside makes the results disappear.
  jQuery('body').bind('click', function(){
    jQuery('.search-results').hide();
  });
});


!function(a,b){if("function"==typeof define&&define.amd)define(["module","exports"],b);else if("undefined"!=typeof exports)b(module,exports);else{var c={exports:{}};b(c,c.exports),a.WOW=c.exports}}(this,function(a,b){"use strict";function c(a,b){if(!(a instanceof b))throw new TypeError("Cannot call a class as a function")}function d(a,b){return b.indexOf(a)>=0}function e(a,b){for(var c in b)if(null==a[c]){var d=b[c];a[c]=d}return a}function f(a){return/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(a)}function g(a){var b=arguments.length<=1||void 0===arguments[1]?!1:arguments[1],c=arguments.length<=2||void 0===arguments[2]?!1:arguments[2],d=arguments.length<=3||void 0===arguments[3]?null:arguments[3],e=void 0;return null!=document.createEvent?(e=document.createEvent("CustomEvent"),e.initCustomEvent(a,b,c,d)):null!=document.createEventObject?(e=document.createEventObject(),e.eventType=a):e.eventName=a,e}function h(a,b){null!=a.dispatchEvent?a.dispatchEvent(b):b in(null!=a)?a[b]():"on"+b in(null!=a)&&a["on"+b]()}function i(a,b,c){null!=a.addEventListener?a.addEventListener(b,c,!1):null!=a.attachEvent?a.attachEvent("on"+b,c):a[b]=c}function j(a,b,c){null!=a.removeEventListener?a.removeEventListener(b,c,!1):null!=a.detachEvent?a.detachEvent("on"+b,c):delete a[b]}function k(){return"innerHeight"in window?window.innerHeight:document.documentElement.clientHeight}Object.defineProperty(b,"__esModule",{value:!0});var l,m,n=function(){function a(a,b){for(var c=0;c<b.length;c++){var d=b[c];d.enumerable=d.enumerable||!1,d.configurable=!0,"value"in d&&(d.writable=!0),Object.defineProperty(a,d.key,d)}}return function(b,c,d){return c&&a(b.prototype,c),d&&a(b,d),b}}(),o=window.WeakMap||window.MozWeakMap||function(){function a(){c(this,a),this.keys=[],this.values=[]}return n(a,[{key:"get",value:function(a){for(var b=0;b<this.keys.length;b++){var c=this.keys[b];if(c===a)return this.values[b]}}},{key:"set",value:function(a,b){for(var c=0;c<this.keys.length;c++){var d=this.keys[c];if(d===a)return this.values[c]=b,this}return this.keys.push(a),this.values.push(b),this}}]),a}(),p=window.MutationObserver||window.WebkitMutationObserver||window.MozMutationObserver||(m=l=function(){function a(){c(this,a),"undefined"!=typeof console&&null!==console&&(console.warn("MutationObserver is not supported by your browser."),console.warn("WOW.js cannot detect dom mutations, please call .sync() after loading new content."))}return n(a,[{key:"observe",value:function(){}}]),a}(),l.notSupported=!0,m),q=window.getComputedStyle||function(a){var b=/(\-([a-z]){1})/g;return{getPropertyValue:function(c){"float"===c&&(c="styleFloat"),b.test(c)&&c.replace(b,function(a,b){return b.toUpperCase()});var d=a.currentStyle;return(null!=d?d[c]:void 0)||null}}},r=function(){function a(){var b=arguments.length<=0||void 0===arguments[0]?{}:arguments[0];c(this,a),this.defaults={boxClass:"wow",animateClass:"animated",offset:0,mobile:!0,live:!0,callback:null,scrollContainer:null,resetAnimation:!0},this.animate=function(){return"requestAnimationFrame"in window?function(a){return window.requestAnimationFrame(a)}:function(a){return a()}}(),this.vendors=["moz","webkit"],this.start=this.start.bind(this),this.resetAnimation=this.resetAnimation.bind(this),this.scrollHandler=this.scrollHandler.bind(this),this.scrollCallback=this.scrollCallback.bind(this),this.scrolled=!0,this.config=e(b,this.defaults),null!=b.scrollContainer&&(this.config.scrollContainer=document.querySelector(b.scrollContainer)),this.animationNameCache=new o,this.wowEvent=g(this.config.boxClass)}return n(a,[{key:"init",value:function(){this.element=window.document.documentElement,d(document.readyState,["interactive","complete"])?this.start():i(document,"DOMContentLoaded",this.start),this.finished=[]}},{key:"start",value:function(){var a=this;if(this.stopped=!1,this.boxes=[].slice.call(this.element.querySelectorAll("."+this.config.boxClass)),this.all=this.boxes.slice(0),this.boxes.length)if(this.disabled())this.resetStyle();else for(var b=0;b<this.boxes.length;b++){var c=this.boxes[b];this.applyStyle(c,!0)}if(this.disabled()||(i(this.config.scrollContainer||window,"scroll",this.scrollHandler),i(window,"resize",this.scrollHandler),this.interval=setInterval(this.scrollCallback,50)),this.config.live){var d=new p(function(b){for(var c=0;c<b.length;c++)for(var d=b[c],e=0;e<d.addedNodes.length;e++){var f=d.addedNodes[e];a.doSync(f)}});d.observe(document.body,{childList:!0,subtree:!0})}}},{key:"stop",value:function(){this.stopped=!0,j(this.config.scrollContainer||window,"scroll",this.scrollHandler),j(window,"resize",this.scrollHandler),null!=this.interval&&clearInterval(this.interval)}},{key:"sync",value:function(){p.notSupported&&this.doSync(this.element)}},{key:"doSync",value:function(a){if("undefined"!=typeof a&&null!==a||(a=this.element),1===a.nodeType){a=a.parentNode||a;for(var b=a.querySelectorAll("."+this.config.boxClass),c=0;c<b.length;c++){var e=b[c];d(e,this.all)||(this.boxes.push(e),this.all.push(e),this.stopped||this.disabled()?this.resetStyle():this.applyStyle(e,!0),this.scrolled=!0)}}}},{key:"show",value:function(a){return this.applyStyle(a),a.className=a.className+" "+this.config.animateClass,null!=this.config.callback&&this.config.callback(a),h(a,this.wowEvent),this.config.resetAnimation&&(i(a,"animationend",this.resetAnimation),i(a,"oanimationend",this.resetAnimation),i(a,"webkitAnimationEnd",this.resetAnimation),i(a,"MSAnimationEnd",this.resetAnimation)),a}},{key:"applyStyle",value:function(a,b){var c=this,d=a.getAttribute("data-wow-duration"),e=a.getAttribute("data-wow-delay"),f=a.getAttribute("data-wow-iteration");return this.animate(function(){return c.customStyle(a,b,d,e,f)})}},{key:"resetStyle",value:function(){for(var a=0;a<this.boxes.length;a++){var b=this.boxes[a];b.style.visibility="visible"}}},{key:"resetAnimation",value:function(a){if(a.type.toLowerCase().indexOf("animationend")>=0){var b=a.target||a.srcElement;b.className=b.className.replace(this.config.animateClass,"").trim()}}},{key:"customStyle",value:function(a,b,c,d,e){return b&&this.cacheAnimationName(a),a.style.visibility=b?"hidden":"visible",c&&this.vendorSet(a.style,{animationDuration:c}),d&&this.vendorSet(a.style,{animationDelay:d}),e&&this.vendorSet(a.style,{animationIterationCount:e}),this.vendorSet(a.style,{animationName:b?"none":this.cachedAnimationName(a)}),a}},{key:"vendorSet",value:function(a,b){for(var c in b)if(b.hasOwnProperty(c)){var d=b[c];a[""+c]=d;for(var e=0;e<this.vendors.length;e++){var f=this.vendors[e];a[""+f+c.charAt(0).toUpperCase()+c.substr(1)]=d}}}},{key:"vendorCSS",value:function(a,b){for(var c=q(a),d=c.getPropertyCSSValue(b),e=0;e<this.vendors.length;e++){var f=this.vendors[e];d=d||c.getPropertyCSSValue("-"+f+"-"+b)}return d}},{key:"animationName",value:function(a){var b=void 0;try{b=this.vendorCSS(a,"animation-name").cssText}catch(c){b=q(a).getPropertyValue("animation-name")}return"none"===b?"":b}},{key:"cacheAnimationName",value:function(a){return this.animationNameCache.set(a,this.animationName(a))}},{key:"cachedAnimationName",value:function(a){return this.animationNameCache.get(a)}},{key:"scrollHandler",value:function(){this.scrolled=!0}},{key:"scrollCallback",value:function(){if(this.scrolled){this.scrolled=!1;for(var a=[],b=0;b<this.boxes.length;b++){var c=this.boxes[b];if(c){if(this.isVisible(c)){this.show(c);continue}a.push(c)}}this.boxes=a,this.boxes.length||this.config.live||this.stop()}}},{key:"offsetTop",value:function(a){for(;void 0===a.offsetTop;)a=a.parentNode;for(var b=a.offsetTop;a.offsetParent;)a=a.offsetParent,b+=a.offsetTop;return b}},{key:"isVisible",value:function(a){var b=a.getAttribute("data-wow-offset")||this.config.offset,c=this.config.scrollContainer&&this.config.scrollContainer.scrollTop||window.pageYOffset,d=c+Math.min(this.element.clientHeight,k())-b,e=this.offsetTop(a),f=e+a.clientHeight;return d>=e&&f>=c}},{key:"disabled",value:function(){return!this.config.mobile&&f(navigator.userAgent)}}]),a}();b["default"]=r,a.exports=b["default"]});
jQuery(document).ready(function () { 
  var scrolled = false;
  window.addEventListener('scroll', _.debounce(function() {
    if (!scrolled) {
      scrolled = true;
      new WOW().init();
    }
  }, 20));  
  jQuery('.shopify-section').eq(1).find("*").removeClass('wow');
  jQuery('.shopify-section').eq(2).find("*").removeClass('wow');
  if (window.matchMedia("(max-width: 1024px)").matches) { jQuery('.shopify-section').eq(3).find("*").removeClass('wow'); }
}); 
  
  
// fonction accordeon pour mobile
function accordeonMobile (selector,opacity) { 
  const panelTitles = document.querySelectorAll(selector);
  for (let i = 0; i < panelTitles.length; i++) {
   const panelTitle = panelTitles[i];
   panelTitle.classList.add("dg-panel-title");
   const addChevron = '<img alt="" class="dg-panel-chevron" src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB2ZXJzaW9uPSIxLjEiIGlkPSJDYXBhXzEiIHg9IjBweCIgeT0iMHB4IiB2aWV3Qm94PSIwIDAgMjU2IDI1NiIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgMjU2IDI1NjsiIHhtbDpzcGFjZT0icHJlc2VydmUiIHdpZHRoPSI1MTIiIGhlaWdodD0iNTEyIj48Zz48Zz4KCTxnPgoJCTxwb2x5Z29uIHBvaW50cz0iMjI1LjgxMyw0OC45MDcgMTI4LDE0Ni43MiAzMC4xODcsNDguOTA3IDAsNzkuMDkzIDEyOCwyMDcuMDkzIDI1Niw3OS4wOTMgICAiIGRhdGEtb3JpZ2luYWw9IiMwMDAwMDAiIGNsYXNzPSJhY3RpdmUtcGF0aCIgc3R5bGU9ImZpbGw6I0FGQUZBRiIgZGF0YS1vbGRfY29sb3I9IiMwMDAwMDAiPjwvcG9seWdvbj4KCTwvZz4KPC9nPjwvZz4gPC9zdmc+" />';
   panelTitle.insertAdjacentHTML('beforeend', addChevron);
   const panelContent = panelTitles[i].nextElementSibling;
   panelContent.classList.add("dg-panel-hidden");   
   panelTitle.addEventListener("click", function() {    
    panelContent.classList.toggle("dg-panel-show");    
     panelTitle.classList.toggle("footer-open"); 
   });
  }
}

function simulateLink() {
  let gridImages = document.querySelectorAll('.product-grid-image--centered');
  for (let i = 0; i < gridImages.length; i++) {       
    gridImages[i].addEventListener('click', function() {
      let link = gridImages[i].dataset.link;
      console.log(link);
      window.location.href = link;        
    });
  }
}
    
        
simulateLink();
    

if (window.matchMedia("(max-width: 600px)").matches) {

accordeonMobile("footer .h3","9");
  

const hasWidget = document.querySelectorAll('.widget');
if(hasWidget[0]) {
  accordeonMobile(".widget h3","9");
} 
  
}   

    
